import { render } from "./shobsho.vue?vue&type=template&id=816ad0dc&scoped=true"
import script from "./shobsho.vue?vue&type=script&lang=js"
export * from "./shobsho.vue?vue&type=script&lang=js"

import "./shobsho.vue?vue&type=style&index=0&id=816ad0dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-816ad0dc"]])

export default __exports__